import React from "react";
import { Grid, Typography, CircularProgress } from "@mui/material";
import { formatMoney } from "../../pipes/PriceFormatter";

interface OrderSummaryMobileProps {
    orderType?: string;
    subtotal: number;
    serviceChargeTotal: number;
    gratuityTotal: number;
    deliveryFee: number;
    totalTax: number;
    total: number;
    calculatePaymentLoading: boolean;
}

const OrderSummaryMobile: React.FC<OrderSummaryMobileProps> = ({
    orderType,
    subtotal,
    serviceChargeTotal,
    gratuityTotal,
    deliveryFee,
    totalTax,
    total,
    calculatePaymentLoading,
}) => {
    return (
        <Grid container mt={1}>
            <Grid item xs={6} sm={6}>
                <Typography sx={{ fontSize: { xs: "18px" } }}>
                    Items Subtotal:
                </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <Typography sx={{ fontSize: { xs: "18px" }, textAlign: "right" }}>
                    {calculatePaymentLoading ? (
                        <CircularProgress color="secondary" size={20} />
                    ) : (
                        "$" + formatMoney(subtotal)
                    )}
                </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <Typography sx={{ fontSize: { xs: "18px" } }}>
                    Service Charge:
                </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <Typography sx={{ fontSize: { xs: "18px" }, textAlign: "right" }}>
                    {calculatePaymentLoading ? (
                        <CircularProgress color="secondary" size={20} />
                    ) : (
                        "$" + formatMoney(serviceChargeTotal)
                    )}
                </Typography>
            </Grid>
            {gratuityTotal !== 0 && (
                <>
                    <Grid item xs={6} sm={6}>
                        <Typography sx={{ fontSize: { xs: "18px" } }}>Gratuity:</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography sx={{ fontSize: { xs: "18px" }, textAlign: "right" }}>
                            {calculatePaymentLoading ? (
                                <CircularProgress color="secondary" size={20} />
                            ) : (
                                "$" + formatMoney(gratuityTotal)
                            )}
                        </Typography>
                    </Grid>
                </>
            )}
            {orderType === "Delivery" && (
                <>
                    <Grid item xs={6} sm={6}>
                        <Typography sx={{ fontSize: { xs: "18px" } }}>
                            Delivery Fee:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography sx={{ fontSize: { xs: "18px" }, textAlign: "right" }}>
                            {calculatePaymentLoading ? (
                                <CircularProgress color="secondary" size={20} />
                            ) : (
                                "$" + formatMoney(deliveryFee || 0)
                            )}
                        </Typography>
                    </Grid>
                </>
            )}
            <Grid item xs={6} sm={6}>
                <Typography sx={{ fontSize: { sm: "18px", fontWeight: 600 } }}>
                    TOTAL:
                </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <Typography
                    sx={{
                        fontSize: {
                            sm: "18px",
                            fontWeight: 600,
                            textAlign: "right",
                        },
                    }}
                >
                    {calculatePaymentLoading ? (
                        <CircularProgress color="secondary" size={20} />
                    ) : (
                        "$" + formatMoney(total)
                    )}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default OrderSummaryMobile;
